import {defineSlotRecipe} from '@chakra-ui/react3'

export const galleryRecipe = defineSlotRecipe({
    slots: [
        'mainContainer',
        'thumbsContainer',
        'galleryContainer',
        'wishlistButtonContainer',
        'hotspotButton'
    ],
    base: {
        mainContainer: {
            position: 'relative',
            height: '100%',
            flexDir: {base: 'column', s: 'row'},
            paddingInline: {base: 'spacing-24', s: 0},
            gap: {s: 'spacing-16'}
        },
        thumbsContainer: {
            position: 'relative',
            display: {base: 'none', s: 'flex'},
            width: 'spacing-90',
            flexGrow: 0,
            flexShrink: 0,
            flexBasis: 'spacing-90'
        },
        galleryContainer: {
            position: 'relative',
            flex: {base: 'none', s: '1'},
            px: {base: 0, s: 0},
            minW: 0,
            height: '100%',
            aspectRatio: 1,
            bg: 'bg'
        },
        wishlistButtonContainer: {
            position: 'absolute',
            top: 'spacing-16',
            right: 'spacing-16',
            zIndex: 'overlay',
            pointerEvents: 'auto'
        },
        hotspotButton: {
            position: 'absolute',
            left: 'var(--hotspot-x)',
            top: 'var(--hotspot-y)',
            transform: 'translate(-50%, -50%)',
            height: {base: '1.5rem', s: '2.125rem'},
            width: {base: '1.5rem', s: '2.125rem'},
            minWidth: {base: '1.5rem', s: '2.125rem'},
            flexShrink: 0,
            borderRadius: 'full',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
            cursor: 'pointer',
            outline: 'none',
            backgroundColor: 'background.overlay.medium',
            _before: {
                content: '""',
                width: '0.75rem',
                height: '0.75rem',
                borderRadius: 'full',
                backgroundColor: 'white'
            },
            _selected: {
                backgroundColor: 'background.overlay.strong-inverted',
                _before: {backgroundColor: 'background.actions.on-media.active'}
            },
            _hover: {
                backgroundColor: 'background.overlay.strong',
                _before: {backgroundColor: 'background.actions.on-media.white'}
            },
            _focusVisible: {
                outlineWidth: '1px',
                outlineStyle: 'solid',
                outlineColor: 'border.strong',
                outlineOffset: '3px'
            }
        }
    }
})
